




























































































































































































import { AccessLogApi } from '@/api/access-log';
import { ClientAccountsApi } from '@/api/client-accounts';
import { CreateAccessLogResponse } from '@/api/responses/access-logs/create-access-log-response';
import { Forbidden } from '@/api/responses/forbidden';
import { NotFound } from '@/api/responses/not-found';
import bookAppointmentDialog from '@/components/appointments/book-appointment-dialog.vue';
import addDeedDialog from '@/components/client/view-client/add-deed-dialog.vue';
import addFactFindDialog from '@/components/client/view-client/add-fact-find-dialog.vue';
import addNoteDialog from '@/components/client/view-client/add-note-dialog.vue';
import addPartnerDialog from '@/components/client/view-client/add-partner-dialog.vue';
import addPowerOfAttorneyDialog from '@/components/client/view-client/add-power-of-attorney-dialog.vue';
import addProductDialog from '@/components/client/view-client/add-product-dialog.vue';
import addWillDialog from '@/components/client/view-client/add-will-dialog.vue';
import clientAdditionalDetails from '@/components/client/view-client/additional.vue';
import clientAddressDetails from '@/components/client/view-client/address.vue';
import clientAppointments from '@/components/client/view-client/appointments.vue';
import contactHistory from '@/components/client/view-client/contact-history.vue';
import clientCourtOfProtectionWarning from '@/components/client/view-client/court-of-protection-banner.vue';
import clientDeeds from '@/components/client/view-client/deeds.vue';
import clientDetails from '@/components/client/view-client/details.vue';
import clientDoNotContactWarning from '@/components/client/view-client/do-not-contact-banner.vue';
import clientAdditionalDocuments from '@/components/client/view-client/documents.vue';
import clientFactFind from '@/components/client/view-client/fact-find.vue';
import clientLockedWarning from '@/components/client/view-client/locked-banner.vue';
import logInteractionDialog from '@/components/client/view-client/log-interaction-dialog.vue';
import clientMarketingDetails from '@/components/client/view-client/marketing.vue';
import clientNotes from '@/components/client/view-client/notes.vue';
import clientPowerOfAttorneys from '@/components/client/view-client/power-of-attorneys.vue';
import clientSensitiveWarning from '@/components/client/view-client/sensitive-banner.vue';
import willHistory from '@/components/client/view-client/will-history.vue';
import clientWill from '@/components/client/view-client/will.vue';
import loading from '@/components/loading.vue';
import { AccessActionType } from '@/shared/access-action-type';
import { AccessType } from '@/shared/access-type';
import { Appointment } from '@/shared/appointments/appointment';
import { AppointmentOutcome } from '@/shared/appointments/appointment-outcome';
import { ClientAccount } from '@/shared/clients/client-account';
import { ClientContactHistory } from '@/shared/clients/client-account-contact-history';
import { ClientAccountDeed } from '@/shared/clients/client-account-deed';
import { ClientAccountFactFind } from '@/shared/clients/client-account-fact-find';
import { ClientAccountNote } from '@/shared/clients/client-account-note';
import { ClientAccountWill } from '@/shared/clients/client-account-will';
import { ClientPowerOfAttorney } from '@/shared/clients/client-power-of-attorney';
import { Interaction } from '@/shared/interaction';
import { AdditionalDocumentType } from '@/shared/types/additional-document-type';
import { ClientStatusType } from '@/shared/types/client-status-type';
import { ClientTitleType } from '@/shared/types/client-title-type';
import { User } from '@/shared/user';
import { DateTime } from 'luxon';
import { Validator } from 'vee-validate';
import { Component, Provide, Vue, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { Getter, namespace } from 'vuex-class';

const partnerPracticesModule = namespace('partnerPractices');
const typesModule = namespace('types');
const userModule = namespace('user');
const usersModule = namespace('users');
const clientAccountApi = new ClientAccountsApi();
const accessLogApi = new AccessLogApi();

Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate',
]);

@Component({
    components: {
        clientDetails,
        clientAddressDetails,
        clientAdditionalDetails,
        clientAdditionalDocuments,
        clientMarketingDetails,
        addProductDialog,
        addDeedDialog,
        addFactFindDialog,
        addWillDialog,
        addPowerOfAttorneyDialog,
        addNoteDialog,
        bookAppointmentDialog,
        logInteractionDialog,
        addPartnerDialog,
        clientDeeds,
        clientFactFind,
        clientPowerOfAttorneys,
        clientWill,
        clientNotes,
        clientAppointments,
        contactHistory,
        willHistory,
        clientSensitiveWarning,
        clientDoNotContactWarning,
        clientCourtOfProtectionWarning,
        clientLockedWarning,
        loading,
    },
})
export default class ViewClient extends Vue {
    @Provide('$validator') public $validator!: Validator;
    @Getter public isDirty!: boolean;

    @partnerPracticesModule.Getter('partnerPracticeName') private partnerPracticeName!: (partnerPracticeId: string | null) => string;

    @typesModule.Getter('activeClientStatusTypes') public clientStatusTypes!: Array<ClientStatusType>;
    @typesModule.Getter('activeClientTitleTypes') public titleTypes!: Array<ClientTitleType>;
    @typesModule.Getter('activeAdditionalDocumentTypes') public allAdditionalDocumentTypes!: Array<AdditionalDocumentType>;

    @userModule.Getter('user') public currentUser!: User;
    @userModule.Getter('isAdministrator') public isAdministrator!: boolean;

    @usersModule.Getter('users') private users!: Array<User>;
    private originalClient: ClientAccount | null = null;
    private client: ClientAccount | null = null;
    private removedWills: Array<ClientAccountWill> = new Array<ClientAccountWill>();
    private notes: Array<ClientAccountNote> = new Array<ClientAccountNote>();
    private appointments: Array<Appointment> = new Array<Appointment>();
    private contactHistory: ClientContactHistory | null = null;
    private willHistoryItems: Array<ClientAccountWill> = new Array<ClientAccountWill>();
    private selectedDeed: ClientAccountDeed | null = null;
    private productDialogVisible: boolean = false;
    private addDeedDialogVisible: boolean = false;
    private factFindDialogVisible: boolean = false;
    private addWillDialogVisible: boolean = false;
    private addPowerOfAttorneyDialogVisible: boolean = false;
    private addNoteDialogVisible: boolean = false;
    private bookAppointmentDialogVisible: boolean = false;
    private addPartnerDialogVisible: boolean = false;
    private logInteractionDialogVisible: boolean = false;
    private confirmationDialogVisible: boolean = false;
    private confirmAssignedToChangedDialogVisible: boolean = false;
    private currentTab: number = 0;
    private detailsValid: boolean = true;
    private addressValid: boolean = true;
    private additionalInformationValid: boolean = true;
    private loading: boolean = true;
    private saving: boolean = false;
    private additionalDocumentsValid: boolean = true;
    private accessLogId: string | null = null;
    private assignPartnerConfirmed: boolean = false;

    private get accountStatusText(): string {
        const clientStatusType = this.clientStatusTypes.find((type) => type.id === this.originalClient!.accountStatusId);
        return clientStatusType == null ? '' : clientStatusType.value;
    }

    private get accountStatusBadgeColor(): string {
        switch (this.accountStatusText.toLowerCase().trim()) {
            case 'client':
                return 'success';
            case 'deceased':
                return 'secondary';
            case 'lead':
                return 'warning';
            case 'archived':
                return 'danger';
            case 'business will client':
                return 'dark';
            default:
                return 'light';
        }
    }

    private get canBookAppointment(): boolean {
        const clientStatusType = this.clientStatusTypes.find((type) => type.id === this.client!.accountStatusId);

        return clientStatusType == null
            ? false
            : !this.client!.doNotContact
            && !clientStatusType.isDeceased
            && !clientStatusType.isAccountArchived;
    }

    private get canAddPartner(): boolean {
        return this.client!.partner == null;
    }

    private get canRemovePartner(): boolean {
        return this.isAdministrator && this.client!.partner != null;
    }

    @Watch('client', { deep: true })
    private onClientChanged(newValue: ClientAccount, oldValue: ClientAccount | null): void {
        if (oldValue != null && newValue.id === oldValue.id) {
            this.$store.commit('setDirty', true);
        }
    }
    @Watch('$route')
    private async onRouteChanged(newValue: Route, oldValue: Route | null): Promise<void> {
        this.loading = true;
        await this.loadClientAsync(newValue.params.id);
        this.loading = false;
    }
    private getFullName(client: ClientAccount): string {
        const titleType = this.titleTypes.find((t) => t.id === this.originalClient!.titleId);
        let title = titleType == null ? null : titleType.value;

        if (title === 'Unknown') {
            title = null;
        }

        const fullName = [title, this.originalClient!.firstName, this.originalClient!.lastName].join(' ').trim();

        return fullName;
    }

    private getUserName(userId: string | null): string {
        const user = this.users.find((u) => u.id === userId);
        return user == null ? userId! : `${user.firstName == null ? '' : user.firstName} ${user.lastName == null ? '' : user.lastName}`;
    }

    private async loadClientAsync(id: string): Promise<void> {
        document.title = `Loading client... - Right Legal Group`;

        try {
            this.originalClient = await clientAccountApi.getClientAccountByIdAsync(id);

            this.client = {
                ...this.originalClient,
                dateOfBirth: this.originalClient.dateOfBirth == null ? null : DateTime.fromISO(this.originalClient.dateOfBirth as string, { zone: 'UTC' }).toJSDate(),
                matterReceived: this.originalClient.matterReceived == null ? null : DateTime.fromISO(this.originalClient.matterReceived as string, { zone: 'UTC' }).toJSDate(),
                matterOpened: this.originalClient.matterOpened == null ? null : DateTime.fromISO(this.originalClient.matterOpened as string, { zone: 'UTC' }).toJSDate(),
                matterClosed: this.originalClient.matterClosed == null ? null : DateTime.fromISO(this.originalClient.matterClosed as string, { zone: 'UTC' }).toJSDate(),
                lockedDate: this.originalClient.lockedDate == null ? null : DateTime.fromISO(this.originalClient.lockedDate as string, { zone: 'UTC' }).toJSDate(),
                partner: this.originalClient.partner == null ? null : { ...this.originalClient.partner },
                factFind: this.originalClient.factFind == null ? null : { ...this.originalClient.factFind },
                will: this.originalClient.will == null ? null : { ...this.originalClient.will, guardians: [...this.originalClient.will.guardians], executors: [...this.originalClient.will.executors] },
                additionalDocuments: [...this.originalClient.additionalDocuments],
                powerOfAttorneys: [...this.originalClient.powerOfAttorneys],
                deeds: [...this.originalClient.deeds],
            };

            this.notes = [...this.client.noteHistory];
            this.contactHistory = {
                emailHistory: [...this.client.emailHistory],
                interactionHistory: [...this.client.interactionHistory],
                messageHistory: [...this.client.messageHistory],
                taskHistory: [...this.client.taskHistory],
            };
            this.willHistoryItems = [...this.client.willHistory];
            this.appointments = await clientAccountApi.getClientAppointmentBookingsAsync(id);

            this.$store.commit('setDirty', false);

            await this.$validator.errors.clear();

            const fullName = this.getFullName(this.originalClient!);
            document.title = `${fullName} - ${this.originalClient!.accountNo} - Right Legal Group`;
            this.$route.meta.breadcrumbTitle = `${fullName} - ${this.originalClient!.accountNo}`;
        } catch (e) {
            if (e instanceof Forbidden) {
                this.$router.push({ name: 'forbidden' });
                return;
            } else if (e instanceof NotFound) {
                this.$router.push({ path: '/not-found' });
                return;
            } else if (e instanceof Error) {
                this.$snackbar.open({ message: e.message, type: 'is-danger' });
            } else {
                this.$snackbar.open({ message: `Could not load client, please try again.`, type: 'is-danger' });
            }
        }
    }
    private showAddProductDialog(): void {
        this.productDialogVisible = true;
    }
    private showAddNoteDialog(): void {
        this.addNoteDialogVisible = true;
    }
    private showBookAppointmentDialog(): void {
        this.bookAppointmentDialogVisible = true;
    }
    private showAddPartnerDialog(): void {
        this.addPartnerDialogVisible = true;
    }
    private showLogInteractionDialog(): void {
        this.logInteractionDialogVisible = true;
    }
    private showDeleteConfirmationDialog(): void {
        this.confirmationDialogVisible = true;
    }
    private onProductSelected(product: string): void {
        switch (product) {
            case 'will':
                this.addWillDialogVisible = true;
                break;
            case 'power-of-attorney':
                this.addPowerOfAttorneyDialogVisible = true;
                break;
            case 'deed':
                this.addDeedDialogVisible = true;
                break;
            case 'fact-find':
                this.factFindDialogVisible = true;
                break;
        }

        this.productDialogVisible = false;
    }
    private onPartnerPracticeChanged(): void {
        if (this.client!.partnerPracticeId === '00000000-0000-0000-0000-000000000000') {
            this.client!.isAcquisition = true;
            return;
        }

        this.client!.isAcquisition = this.originalClient!.isAcquisition;
        this.confirmAssignedToChangedDialogVisible = (this.client!.partnerPracticeId != null &&
            this.client!.isAcquisition &&
            this.client!.partnerPracticeId !== '00000000-0000-0000-0000-000000000000' &&
            this.originalClient!.partnerPracticeId !== this.client!.partnerPracticeId)!;
    }
    private async onDeedAdded(deed: ClientAccountDeed): Promise<void> {
        this.client!.deeds.push(deed);
        this.onCancel();
    }
    private async onFactFindAdded(factFind: ClientAccountFactFind): Promise<void> {
        this.client!.factFind = factFind;
        this.onCancel();
    }
    private onFactFindDeleted(): void {
        this.client!.factFind = null;
    }
    private async onPowerOfAttorneyAdded(powerOfAttorney: ClientPowerOfAttorney, addAnother: boolean): Promise<void> {
        this.client!.powerOfAttorneys.push(powerOfAttorney);

        if (!addAnother) {
            this.onCancel();
        }
    }
    private async onWillAdded(will: ClientAccountWill): Promise<void> {
        this.client!.will = will;
        this.onCancel();
    }
    private async onWillRemoved(will: ClientAccountWill): Promise<void> {
        this.removedWills.push(will);
        this.client!.will = null;
    }
    private async onNoteAdded(note: ClientAccountNote): Promise<void> {
        this.$snackbar.open({ message: `Note successfully added`, type: 'is-success' });
        this.onCancel();
        await this.loadClientAsync(this.client!.id!);
    }
    private async onInteractionLogged(interaction: Interaction): Promise<void> {
        this.$snackbar.open({ message: `Interaction successfully logged`, type: 'is-success' });
        this.onCancel();
        await this.loadClientAsync(this.client!.id!);
    }
    private async onInteractionUpdated(): Promise<void> {
        this.$snackbar.open({ message: `Interaction successfully updated`, type: 'is-success' });
        this.onCancel();
        await this.loadClientAsync(this.client!.id!);
    }
    private async onNoteUpdated(): Promise<void> {
        this.$snackbar.open({ message: `Note successfully updated`, type: 'is-success' });
        this.onCancel();
        await this.loadClientAsync(this.client!.id!);
    }
    private async onNoteDeleted(): Promise<void> {
        this.$snackbar.open({ message: `Note successfully deleted`, type: 'is-success' });
        this.onCancel();
        await this.loadClientAsync(this.client!.id!);
    }
    private async onAdditionalDocumentsChanged(documents: Array<{ id: string, otherText: string | null }>): Promise<void> {
        this.client!.additionalDocuments = documents.map((d) => {
            return {
                additionalDocumentTypeId: d.id,
                otherText: d.otherText,
            };
        });

        this.onCancel();
    }
    private async onInteractionDeleted(): Promise<void> {
        this.$snackbar.open({ message: `Interaction successfully deleted`, type: 'is-success' });
        this.onCancel();
        await this.loadClientAsync(this.client!.id!);
    }
    private async onWillHistoryUpdated(will: ClientAccountWill): Promise<void> {
        this.$snackbar.open({ message: `Will history successfully updated`, type: 'is-success' });
        this.onCancel();
        await this.loadClientAsync(this.client!.id!);
    }
    private async onWillHistoryDeleted(will: ClientAccountWill): Promise<void> {
        this.$snackbar.open({ message: `Will history successfully deleted`, type: 'is-success' });
        this.onCancel();
        await this.loadClientAsync(this.client!.id!);
    }
    private async onAppointmentBooked(): Promise<void> {
        this.$snackbar.open({ message: `Appointment successfully booked`, type: 'is-success' });
        this.onCancel();
        await this.loadClientAsync(this.client!.id!);
    }
    private async onAppointmentUpdated(): Promise<void> {
        this.$snackbar.open({ message: `Appointment successfully updated`, type: 'is-success' });
        this.onCancel();
        await this.loadClientAsync(this.client!.id!);
    }
    private async onAppointmentRebooked(): Promise<void> {
        this.$snackbar.open({ message: `Appointment successfully re-booked`, type: 'is-success' });
        this.onCancel();
        await this.loadClientAsync(this.client!.id!);
    }
    private async onAppointmentCompleted(): Promise<void> {
        this.$snackbar.open({ message: `Appointment successfully completed`, type: 'is-success' });
        this.onCancel();
        await this.loadClientAsync(this.client!.id!);
    }
    private async onAppointmentOutcomeChanged(): Promise<void> {
        this.$snackbar.open({ message: `Appointment outcome successfully updated`, type: 'is-success' });
        this.onCancel();
        await this.loadClientAsync(this.client!.id!);
    }
    private async onAppointmentRemoved(appointment: Appointment): Promise<void> {
        this.$snackbar.open({ message: `Appointment successfully deleted`, type: 'is-success' });
        this.onCancel();
        await this.loadClientAsync(this.client!.id!);
    }
    private async onOutcomeRemoved(appointment: Appointment): Promise<void> {
        this.$snackbar.open({ message: `Appointment outcome successfully deleted`, type: 'is-success' });
        this.onCancel();
        await this.loadClientAsync(this.client!.id!);
    }
    private async onAppointmentMarkedAsBanked(appointment: AppointmentOutcome): Promise<void> {
        this.$snackbar.open({ message: `Appointment successfully marked as banked`, type: 'is-success' });
        this.onCancel();
        await this.loadClientAsync(this.client!.id!);
    }
    private async onPartnerAdded(client: ClientAccount): Promise<void> {
        await clientAccountApi.assignClientPartnerAsync(this.originalClient!, client.id!);
        this.$snackbar.open({ message: `Partner successfully added.`, type: 'is-success' });
        this.onCancel();
        await this.loadClientAsync(this.client!.id!);
    }
    private async onPartnerRemoved(): Promise<void> {
        await clientAccountApi.removeClientPartnerAsync(this.client!.id!, this.client!.partner!.id!);
        this.$snackbar.open({ message: `Partner successfully removed.`, type: 'is-success' });
        this.onCancel();
        await this.loadClientAsync(this.client!.id!);
    }
    private async handleDeleteClient(): Promise<void> {
        try {
            await clientAccountApi.deleteClientAsync(this.client!);
            await this.updateAccessLog();
            this.$store.commit('setDirty', false);
            this.$snackbar.open({ message: `Client successfully deleted`, type: 'is-success' });
            this.onCancel();
            this.$router.push({ name: 'clients' });
        } catch (e) {
            this.$snackbar.open({ message: `Client successfully deleted`, type: 'is-danger' });
        }
    }
    private onConfirmAssignedToPermanent(): void {
        this.client!.isAcquisition = false;
        this.onCancel();
    }
    private onComfirmAssignedToAppointmentOnly(): void {
        this.client!.isAcquisition = true;
        this.onCancel();
    }
    private onCancel(): void {
        this.productDialogVisible = false;
        this.addDeedDialogVisible = false;
        this.factFindDialogVisible = false;
        this.addWillDialogVisible = false;
        this.addPowerOfAttorneyDialogVisible = false;
        this.addNoteDialogVisible = false;
        this.bookAppointmentDialogVisible = false;
        this.addPartnerDialogVisible = false;
        this.logInteractionDialogVisible = false;
        this.confirmationDialogVisible = false;
        this.confirmAssignedToChangedDialogVisible = false;
        this.selectedDeed = null;
    }

    private get sensitiveOrCopRemoved(): boolean {
        return (this.originalClient!.isSensitive && !this.client!.isSensitive) || (this.originalClient!.hasCourtOfProtection && !this.client!.hasCourtOfProtection);
    }

    private async showConfirmation(): Promise<void> {
        if (!this.sensitiveOrCopRemoved) {
            await this.saveClient();
        } else {
            this.confirmationDialogVisible = true;
        }
    }
    private async saveClient(): Promise<void> {
        let isValid: boolean = true;

        if (!(await this.$validator.validateAll('client-details'))) {
            this.$snackbar.open({ message: `Could not update client, required fields are missing in 'Details'.`, type: 'is-danger' });
            isValid = false;
        }

        if (!(await this.$validator.validateAll('address-details'))) {
            this.$snackbar.open({ message: `Could not update client, required fields are missing in 'Address'.`, type: 'is-danger' });
            isValid = false;
        }

        if (!(await this.$validator.validateAll('additional-details'))) {
            this.$snackbar.open({ message: `Could not update client, validation errors found in 'Additional Information'.`, type: 'is-danger' });
            isValid = false;
        }

        if (!(await this.$validator.validateAll('national-insurance-number'))) {
            this.$snackbar.open({ message: `Could not update client, required fields are missing in 'Additional Information'.`, type: 'is-danger' });
            isValid = false;
        }

        if (!(await this.$validator.validateAll('additional-documents'))) {
            this.$snackbar.open({ message: `Could not update client, required fields are missing in 'Additional Documents'.`, type: 'is-danger' });
            isValid = false;
        }

        if (!(await this.$validator.validateAll('will-details'))) {
            this.$snackbar.open({ message: `Could not update client, required fields are missing in 'Will'.`, type: 'is-danger' });
            isValid = false;
        }

        if (!isValid) {
            return;
        }

        const partnerPracticeChanged = this.client!.partnerPracticeId !== this.originalClient!.partnerPracticeId;
        const hasPartner = this.client!.partner != null;

        if (hasPartner && partnerPracticeChanged && !this.assignPartnerConfirmed) {
            await this.$confirm.open({
                message: `This client has a partner, if you continue the partner will also be assigned to '${this.partnerPracticeName(this.client!.partnerPracticeId!)}'.`,
                showCancel: true,
                okText: 'Continue',
                cancelText: 'Cancel',
                onOk: () => {
                    this.assignPartnerConfirmed = true;
                    this.saveClient();
                },
                onCancel: () => {
                    this.assignPartnerConfirmed = false;
                    return;
                },
            });
        }

        try {
            this.saving = true;
            await clientAccountApi.updateClientAccountAsync(this.client!);
            await this.updateAccessLog();
            await this.loadClientAsync(this.client!.id!);

            this.$store.commit('setDirty', false);
            this.assignPartnerConfirmed = false;
            this.$snackbar.open({ message: `Client successfully updated.` });

        } catch (e) {
            if (e instanceof Error) {
                this.$snackbar.open({ message: e.message, type: 'is-danger' });
            } else {
                this.$snackbar.open({ message: 'Could not update client, please try again.', type: 'is-danger' });
            }
        }

        this.saving = false;
    }
    private async beforeRouteLeave(to: Route, from: Route, next: any): Promise<void> {
        if (this.client != null && this.client!.lockedDate != null && this.client!.lockedBy === this.currentUser!.id) {
            try {
                await this.$confirm.open({
                    message: 'You have locked this client, to unlock, please log an interaction.',
                    variant: 'danger',
                    okText: 'Back to Client',
                });
                next(false);
            } catch (err) {
                next(false);
            }
        } else if (this.$store.getters.isDirty) {
            try {
                await this.$confirm.open({
                    message: 'You have unsaved changes, if you continue those changes will be lost.',
                    showCancel: true,
                    showContinue: true,
                    okText: 'Save & Exit',
                    continueText: 'Continue Without Saving',
                    cancelText: 'Cancel',
                    onOk: () => {
                        this.saveClient();
                        next();
                    },
                    onContinue: () => {
                        next();
                    },
                    onCancel: () => {
                        next(false);
                    },
                });
                next(false);
            } catch (err) {
                next(false);
            }
            next();
        } else {
            next();
        }
        return;
    }
    private canDeleteClient(): boolean {
        return this.isAdministrator;
    }

    private async createAccessLog(): Promise<void> {
        if (this.client == null) {
            return;
        }

        const roles = this.currentUser.roles.map((r) => r.name).join(', ');

        const response: CreateAccessLogResponse = await accessLogApi.createAccessLog({
            accessType: AccessType.Client,
            accessActionType: AccessActionType.ReadOnly,
            partnerPracticeId: this.client.partnerPracticeId,
            aggregateId: this.client.id!,
            userRoles: roles,
        });

        this.accessLogId = response.id;
    }

    private async updateAccessLog(): Promise<void> {
        if (this.client == null) {
            return;
        }

        await accessLogApi.updateAccessLog(this.accessLogId, this.client.id!);
    }

    public async mounted(): Promise<void> {
        this.loading = true;

        await Promise.all([
            this.$store.dispatch(`partnerPractices/loadPartnerPracticesAsync`),
            this.$store.dispatch(`types/loadTypesAsync`),
            this.$store.dispatch(`types/loadPartnerPracticeTypesAsync`),
            this.$store.dispatch(`users/loadAllUsersAsync`),
        ]);

        const id = this.$route.params.id;
        await this.loadClientAsync(id);
        await this.createAccessLog();

        this.loading = false;
    }
}
